import "./MABCard.css";

interface MABCard {
  item: {
    image: string;
    name: string;
    title: string;
    city: string;
    description: string;
  };
}

const MABCards = ({ item }: MABCard) => {
  const background = `/MAB/${item.image}`;

  return (
    <div className="card-container">
      <div
        className="card-image-wrapper"
        style={{ backgroundImage: `url(${background})` }}
      ></div>
      <div className="card-content-wrapper">
        <h1>{item.name}</h1>
        <p>
          <i>{item.title}</i>
        </p>
      </div>
      <div className="card-overlay">
        <h2>{item.name}</h2>
        <p>
          <i>{item.title}</i>
        </p>
        <p>{item.city}</p>
        <p>{item.description}</p>
      </div>
    </div>
  );
};

export default MABCards;
